<template>
  <div>
    <t-form labelWidth="100px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <e-collapse title="标题" :expand="false">
        <t-form-item label="标题">
          <t-input size="small" v-model="attribute.titleText" :maxcharacter="52"/>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.titleColor"/>
        </t-form-item>
        <t-form-item label="大小">
          <t-input-number size="small" v-model="attribute.titleFontSize" :min="4" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.titleLeft" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.titleTop" :direction="'y'"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="图例" :expand="false">
        <t-form-item label="显示">
          <t-switch v-model="attribute.visualMap.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="位置(X)">
          <e-chart-position v-model="attribute.visualMap.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="位置(Y)">
          <e-chart-position v-model="attribute.visualMap.top" :direction="'y'"/>
        </t-form-item>
        <t-form-item label="指示器">
          <t-input style="width: 80px;margin-left: 5px;" size="small" v-model="attribute.visualMap.text[0]"/>
          <t-input style="width: 80px;margin-left: 5px;" size="small" v-model="attribute.visualMap.text[1]"/>
        </t-form-item>
        <t-form-item label="文本颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.visualMap.textStyle.color"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="地图" :expand="false">
        <t-form-item label="提示框">
          <t-textarea autosize size="small" v-model="attribute.tipFormatter"/>
        </t-form-item>
        <t-form-item label="字颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.geoLabelColor"/>
        </t-form-item>
        <t-form-item label="字大小">
          <t-input-number size="small" v-model="attribute.geoLabelSize" :min="4" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="边界线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.borderColor"/>
        </t-form-item>
        <t-form-item label="允许缩放">
          <t-switch v-model="attribute.roam" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="地图横向位置">
         <t-input-number size="small" v-model="attribute.geoLeft"  :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="地图纵向位置">
          <t-input-number size="small" v-model="attribute.geoTop"  :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="地图初始大小">
          <t-input-number size="small" v-model="attribute.geoZoom"  :step="0.1" :decimal-places="2"/>
        </t-form-item>
        <t-form-item label="省份">
          <t-select v-model="attribute.provinceCode" size="small" @change="changeProvince">
            <t-option label="全国" value="china"/>
            <t-option v-for="(item,index) in cityProvince" :key="index" :label="item.name" :value="item.code"/>
          </t-select>
        </t-form-item>
        <t-form-item label="城市">
          <t-select v-model="attribute.cityCode" size="small" clearable>
            <t-option v-for="(item,index) in cities" :key="index" :label="item.name" :value="item.code"/>
          </t-select>
        </t-form-item>
        <t-form-item label="点击下钻">
          <t-switch v-model="attribute.enableDrillDown" :label="['开启', '关闭']" size="small"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="条件配色" :expand="true" ref="pieceCollapse">
        <t-form-item label="默认颜色">
          <t-color-picker enableAlpha=true :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.areaColor"/>
        </t-form-item>
        <div style="padding: 0 4px 0 4px;">
          <div v-for="(item,index) in attribute.visualMap.pieces" :key="index" class="conditionItem">
            <div>
              <div class="formLabel">标签</div>
              <div class="formItem">{{item.label}}</div>
            </div>
            <div>
              <div class="formLabel">数值区间</div>
              <div class="formItem">{{'['+(item.gte === undefined? '∞':item.gte)+','+(item.lt === undefined ? '∞':item.lt)+')'}}</div>
            </div>
            <div>
              <div class="formLabel">颜色</div>
              <div class="formItem" style="width: 20px;height: 20px;" :style="{backgroundColor:attribute.color[index]}"></div>
            </div>
            <div style="position: absolute;width: 50px;height: 35px;cursor: pointer;top: 0;right: 0">
              <t-icon name="edit" @click="editPiece(item,index)"/>
              <t-icon style="margin-left: 10px" name="delete" @click="delPiece(index)"/>
            </div>
          </div>
          <t-button block @click="addPiece()" :disabled="attribute.visualMap.pieces.length >= 7">新增条件</t-button>
        </div>
      </e-collapse>
    </t-form>
    <t-dialog header="新增条件配色" v-model:visible="modelShow" @confirm="onConfirm" :zIndex="2000" width="640">
      <div style="height: 100%;overflow: hidden">
        <t-form>
          <t-form-item label="标签">
            <t-input v-model="currPiece.label"/>
          </t-form-item>
          <t-form-item label="数值区间">
            <div style="width: 80px;text-align: center">大于等于</div>
            <t-input-number v-model="currPiece.gte"/>
            <div style="width: 80px;text-align: center">小于</div>
            <t-input-number v-model="currPiece.lt"/>
          </t-form-item>
          <t-form-item label="颜色">
            <t-color-picker enableAlpha=true :colorModes="['monochrome']" format="RGBA" size="small" v-model="currPiece.color"/>
          </t-form-item>
        </t-form>
      </div>
    </t-dialog>
  </div>
</template>

<script>
import cityProvince from '@/assets/map/city-province.json'
import {getChildByParentCode} from "@/utils/map-manage";
import EChartPosition from "@/components/designer/e-chart-position";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-map-gc-option",
  components: {EChartPosition,CptData},
  props: {attribute: Object,cptDataForm:Object,},
  data(){
    return {
      cityProvince,
      currentProvince:'',
      cities:[],
      modelShow:false,
      currPiece:{
        label:'',
        gte:0,
        lt:0,
        color:'#000'
      },
      currPieceIndex:null
    }
  },
  created() {
    this.loadChild(this.attribute.provinceCode)
  },
  methods:{
    loadChild(val){
      if(val === 'china'){
        this.cities = [];
      }else{
        this.cities = getChildByParentCode(val)
      }
    },
    changeProvince(val){
      this.attribute.cityCode = ''
      this.loadChild(val)
    },
    onConfirm(){
      if(this.currPiece.gte === null || this.currPiece.gte === ''){
        this.currPiece.gte = undefined
      }
      if(this.currPiece.lt === null || this.currPiece.lt === ''){
        this.currPiece.lt = undefined
      }
      if(this.currPieceIndex !== null){
        const temp = {
          label:this.currPiece.label,
          gte: this.currPiece.gte,
          lt: this.currPiece.lt
        }
        this.attribute.visualMap.pieces.splice(this.currPieceIndex,1,temp)
        if(this.attribute.color[this.currPieceIndex]){
          this.attribute.color[this.currPieceIndex] = this.currPiece.color
        }else{
          this.attribute.color.push(this.currPiece.color)
        }
      }else{
        this.attribute.visualMap.pieces.push(JSON.parse(JSON.stringify(this.currPiece)))
        const index = this.attribute.visualMap.pieces.length - 1
        if(this.attribute.color[index]){
          this.attribute.color[index] = this.currPiece.color
        }else{
          this.attribute.color.push(this.currPiece.color)
        }
        this.$nextTick(()=>{
          this.$refs.pieceCollapse.resize()
        })
      }
      this.modelShow = false
    },
    addPiece(){
      this.currPieceIndex = null
      this.modelShow = true
    },
    editPiece(item, index){
      this.currPieceIndex = index
      this.currPiece.label = item.label
      this.currPiece.gte = item.gte
      this.currPiece.lt = item.lt
      this.currPiece.color = this.attribute.color[index]
      this.modelShow = true
    },
    delPiece(index){
      this.attribute.visualMap.pieces.splice(index,1)
      this.attribute.color.splice(index,1)
    }
  }
}
</script>

<style scoped>
.conditionItem{width: 100%;background: rgba(0,0,0,0.2);padding-top: 6px;line-height: 35px;position: relative;margin-bottom: 4px;}
.formLabel{display: inline-block;width: 100px;text-align: center}
.formItem{display: inline-block;}
</style>
